/* Nuitly — runtime fixes (loaded site-wide via theme.liquid)
   - Bundle picker: sync clicked bundle's variant_id + qty into the form
   - PDP gallery: support left/right swipe on the main image to flip thumbs
   - Plain-form add-to-cart (relies on enable_ajax: false in template)
*/
(function () {
  'use strict';

  function wireBundles(hero) {
    var form = hero.querySelector('form');
    if (!form) return;
    var idIn  = form.querySelector('[name="id"]');
    var qtyIn = form.querySelector('[name="quantity"]');
    var bundles = hero.querySelectorAll('[data-nu-bundle]');
    if (!bundles.length) return;

    function pick(btn) {
      bundles.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      var vid = btn.getAttribute('data-variant-id');
      var qty = btn.getAttribute('data-qty');
      if (vid && idIn)  idIn.value  = vid;
      if (qty && qtyIn) qtyIn.value = qty;
    }

    bundles.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); pick(btn); });
    });

    // Initialise from the bundle marked is-selected (or first)
    var sel = hero.querySelector('[data-nu-bundle].is-selected') || bundles[0];
    if (sel) pick(sel);
  }

  function wireSwipe(hero) {
    var main   = hero.querySelector('[data-nu-main-img]');
    if (!main) return;
    var mainImg = main.querySelector('img');
    if (!mainImg) return;
    var thumbs = hero.querySelectorAll('[data-nu-thumb]');
    if (thumbs.length < 2) return;

    function activate(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var t = thumbs[idx];
      t.classList.add('is-active');
      var img = t.getAttribute('data-img');
      if (img) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = img;
      }
      var alt = t.getAttribute('data-alt');
      if (alt) mainImg.alt = alt;
      // Scroll the active thumb into view
      t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    // Re-wire thumb clicks (instant swap, no waiting)
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); activate(i); });
    });

    // Touch swipe
    var sx = 0, sy = 0, dx = 0, dy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) {
      var p = e.touches[0]; sx = p.clientX; sy = p.clientY; dx = 0; dy = 0; tracking = true;
    }, { passive: true });
    main.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var p = e.touches[0]; dx = p.clientX - sx; dy = p.clientY - sy;
    }, { passive: true });
    main.addEventListener('touchend', function () {
      if (!tracking) return; tracking = false;
      if (Math.abs(dx) < 40) return;             // threshold
      if (Math.abs(dx) < Math.abs(dy)) return;    // mostly vertical = scroll
      var c = current();
      activate(dx < 0 ? c + 1 : c - 1);
    });

    // Desktop: arrow keys when focus inside gallery
    main.tabIndex = 0;
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); activate(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); activate(current() + 1); }
    });
  }

  function init() {
    document.querySelectorAll('[data-nu-hero]').forEach(function (hero) {
      wireBundles(hero);
      wireSwipe(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
